import { useMutation } from '@tanstack/react-query';

import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { searchBusinessByName } from '../../requests/searchBusinessByName';

export const useSearchBusinessByName = () => {
  const { constructGet } = useRequestConstructor();

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: async (name: string) =>
      searchBusinessByName(constructGet, name),
  });

  return { searchBusinessByName: mutateAsync, ...rest };
};
